module.exports = __webpack_public_path__ + "img/glida_vanil_yes.d28fa555.png";